<template>
	<div>

		<div class="loading" style="display:none;">
			<div class="loading_inner">
				<div class="loading-fading-circle">
					<div class="loading-circle1 loading-circle"></div>
					<div class="loading-circle2 loading-circle"></div>
					<div class="loading-circle3 loading-circle"></div>
					<div class="loading-circle4 loading-circle"></div>
					<div class="loading-circle5 loading-circle"></div>
					<div class="loading-circle6 loading-circle"></div>
					<div class="loading-circle7 loading-circle"></div>
					<div class="loading-circle8 loading-circle"></div>
					<div class="loading-circle9 loading-circle"></div>
					<div class="loading-circle10 loading-circle"></div>
					<div class="loading-circle11 loading-circle"></div>
					<div class="loading-circle12 loading-circle"></div>
				</div>
			</div> 
		</div>
				
		<div id="top-view" class="nicednb-container">
			<div class="header-container">
				<div class="header-content">
					<a href="/" class="logo-link"><img src="@/assets/images/common/logo-nicednb.jpg" alt="나이스디앤비"></a>
					<div class="mobile-menu-open"><span class="glyphicon glyphicon-menu-hamburger"></span></div>
					<!-- gnb -->
					<div class="gnb">
						<ul class="menu_wrap">
							<li class="cpMenu"><a href="/cp/company02.do">회사소개</a>
								<ul class="drop-menu menu1">
									<li><a href="/cp/company02.do">CEO인사말</a></li>
									<li><a href="/cp/company03.do">회사연혁</a></li>
									<li><a href="/cp/company04.do">Vision &amp; Value</a></li>
									<li><a href="/cp/company05.do">관계사</a></li>
									<li><a href="/cp/company08.do">이사회</a></li>
									<li><a href="/cp/company09.do">CI 소개</a></li>
									<li><a href="/cp/company07.do">회사위치</a></li>
									<!-- <li><a href="http://www.nicednr.co.kr/" target="_blank" title="새창으로 보기">자회사정보</a></li> -->
								</ul>
							</li>
							<li class="imMenu"><a href="/im/investment08.do?cm_cd=9200">투자정보</a>
								<ul class="drop-menu menu4">
									<li><a href="/im/investment08.do?cm_cd=9200">보도자료</a></li>
									<li><a href="/im/investment01.do">주주구성</a></li>
									<li><a href="/im/investment03.do">공시정보</a></li>
									<li><a href="/im/investment04.do">재무정보</a></li>
									<li><a href="/im/investment05.do?cm_cd=9400">IR자료실</a></li>
									<li><a href="/im/investment06.do">배당정보</a></li>
									<li><a href="/im/investment07.do">정기주총</a></li>
								</ul>
							</li>
							<li class="epMenu"><a href="/ep/employment04.do">인재채용</a>
								<ul class="drop-menu menu7">
									<li><a href="/ep/employment04.do">인재상</a></li>
									<li><a href="/ep/employment05.do">인사제도</a></li>
									<li><a href="/ep/employment06.do">인재육성</a></li>
									<li><a href="/ep/employment07.do">직무소개</a></li>
									<li><a href="https://nice.career.greetinghr.com" target="_blank" title="새창 NICE그룹 채용정보 안내 서비스 홈페이지로 이동합니다.">채용정보</a></li>
								</ul>
							</li>
							<li class="csMenu"><a href="/cs/cs-center01-list.do?cm_cd=9100">고객센터</a>
								<ul class="drop-menu menu6">
									<li><a href="/cs/cs-center01-list.do?cm_cd=9100">공지사항</a></li>
									<li><a href="/cs/cs-center03.do">보안정책</a></li>
									<li><a href="/cs/cs-center04.do">공정거래자율준수</a></li>
									<li><a href="/cs/cs-center05-1.do">전자민원센터-기업</a></li>
									<li><a href="/cs/cs-center05-2.do">전자민원센터-개인</a></li>
									<li><a href="/cs/cs-center07.do">고객권리안내문</a></li>
									<li><a href="/cs/cs-center06.do">제휴 제안</a></li>
								</ul>
							</li>
							<li class="quickMenu"><a href="#">QUICK LINK</a>
								<div class="drop-menu menu8">
									<ul class="quickMenu_sub eval_menu">
										<li><img src="@/assets/images/common/quickLink_01.png" class="mr10">평가사업</li>
										<li>
											<a href="https://www.nicers.co.kr" target="_blank">공공 기관 입찰용 기업평가</a>
											<img src="@/assets/images/common/main_logo_rs.png" class="mr30 ml30">
											<span>T. 02-2122-2308</span>
										</li>
										<li>
											<a href="https://www.nicers.co.kr" target="_blank">민간 기업 입찰용 기업평가</a>
											<img src="@/assets/images/common/main_logo_rs.png">
											<span>T. 02-2122-2550</span>
										</li>
										<li>
											<a href="https://www.nicers.co.kr" target="_blank">ESG 평가</a>
											<img src="@/assets/images/common/main_logo_rs.png">
											<span>T. 02-2122-2337</span>
										</li>
										<li>
											<a href="http://www.gotcb.co.kr/" target="_blank">기술 신용 평가(TCB)</a>
											<img src="@/assets/images/common/main_logo_goTCB.png">
											<span>T. 02-2122-1300</span>
										</li>
									</ul>
									<ul class="quickMenu_sub data_menu">
										<li><img src="@/assets/images/common/quickLink_02.png" class="mr10">정보사업</li>
										<li>
											<a href="https://global.nicednb.com" target="_blank">해외기업정보(글로벌 기업인증, 해외기업 신용조사&#8226;조회 등)</a>
											<span>T. 02-2122-2515</span>
										</li>
										<li>
											<a href="https://www.creport.co.kr/" target="_blank">국내기업정보(정보조회, 데이터 컨설팅,정보 구매 등)</a>
											<span>T. 02-2122-2536</span>
										</li>
										<li>
											<a href="https://biz.gotcb.co.kr/info/information9" target="_blank">데이터 가치평가 / 컨설팅  </a>
											<span>T. 02-2122-2546</span>
										</li>
										<li>
											<a href="/sv/service07.do" target="_blank">데이터 바우처 </a>
											<span>T. 02-2122-2522</span>
										</li>
									</ul>
									<ul class="quickMenu_sub call_menu">
										<li><img src="@/assets/images/common/quickLink_03.png" class="mr10">대표번호</li>
										<li style="padding:0">T. 02-2122-2500</li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
					<!-- //gnb -->
				</div>
				<!-- //header-content -->
				<div class="menu-bg" style=""></div>
			</div>
			<!-- //header-container -->
			
			<!-- mobile-menu -->
			<div class="mnb">
				<div class="mnb-container">
					<div class="mnb-header">
						<a href="/"><span class="glyphicon glyphicon-home"></span> HOME</a>
						<div class="mnb-close"></div>
					</div>
					<!-- //mnb-header -->
					<div class="mnb-content">
						<ul class="mnb-tab">
							<li class="cpMenu"><a data-toggle="tab" href="#mnb-1">회사소개</a></li>
							<li class="svMenu"><a data-toggle="tab" href="#mnb-2">서비스안내</a></li>
							<li class="imMenu"><a data-toggle="tab" href="#mnb-3">투자정보</a></li>
							<li class="pcMenu"><a data-toggle="tab" href="#mnb-4">홍보센터</a></li>
							<li class="csMenu"><a data-toggle="tab" href="#mnb-5">고객센터</a></li>
							<li class="epMenu"><a data-toggle="tab" href="#mnb-6">인재채용</a></li>
						</ul>
						<!-- //mnb-tab -->
						<!-- mnb-content -->
						<div class="mnb-wrap">
							<!-- mnb-1 -->
							<div id="mnb-1" class="mnb-list fade in active">
								<ul>
									<li><a href="/cp/company01.do">개요</a></li>
									<li><a href="/cp/company02.do">CEO인사말</a></li>
									<li><a href="/cp/company03.do">회사연혁</a></li>
									<li><a href="/cp/company04.do">Vision &amp; Value</a></li>
									<li><a href="/cp/company05.do">NICE GROUP</a></li>
									<li><a href="/cp/company06.do">D&amp;B</a></li>
									<li><a href="/cp/company07.do">회사위치</a></li>
									<li><a href="http://www.nicednr.co.kr/" target="_blank" title="새창으로 보기">자회사정보</a></li>
									<li><a href="/cp/company08.do">이사회</a></li>
								</ul>
							</div>
							<!-- //mnb-1 -->
							<!-- mnb-2 -->
							<div id="mnb-2" class="mnb-list fade">
								<ul>
									<li><a href="/sv/service02.do">공공기관 입찰용 평가 서비스</a></li>
									<li><a href="/sv/service03.do">민간기업 제출용 평가 서비스</a>
										<ul>
											<li><a href="/sv/service03.do#service-link-1">민간기업 제출용 평가 안내</a></li>
											<li><a href="/sv/service03.do#service-link-2">기업평가 부가서비스 안내</a></li>
										</ul>
									</li>
									<li><a href="/sv/service04.do">기술신용평가(TCB)</a>
										<ul>
											<li><a href="/sv/service04.do#service-link-1">기술신용 평가</a></li>
											<li><a href="/sv/service04.do#service-link-2">기술가치 평가</a></li>
										</ul>
									</li>
									<li><a href="/sv/service01.do">해외기업정보 서비스</a>
										<ul>
											<li><a href="/sv/service01.do#service-link-1">국제사업자등록번호 D-U-N-S<sup>®</sup> Number</a></li>
											<li><a href="/sv/service01.do#service-link-2">자사 및 해외기업 신용조사 보고서</a></li>
											<li><a href="/sv/service01.do#service-link-3">해외기업정보 조회 서비스</a></li>
											<li><a href="/sv/service01.do#service-link-8">Compliance(AML:자금세탁방지) 서비스</a></li>
											<li><a href="/sv/service01.do#service-link-9">API 서비스 - Direct+</a></li>
											<li><a href="/sv/service01.do#service-link-10">정부지원사업 - 데이터 및 수출바우처</a></li>
											<li><a href="/sv/service01.do#service-link-4">해외기업 DATA</a></li>
											<li><a href="/sv/service01.do#service-link-5">수출 지원 서비스</a></li>
											<li><a href="/sv/service01.do#service-link-6">해외시장조사 서비스</a></li>
											<li><a href="/sv/service01.do#service-link-7">기타서비스</a></li>
										</ul>
									</li>
									<li><a href="/sv/service05.do">기업정보 서비스</a></li>
									<li><a href="/sv/service06.do">컨설팅 서비스</a></li>
								</ul>
							</div>
							<!-- //mnb-2 -->
							<!-- mnb-3 -->
							<div id="mnb-3" class="mnb-list fade">
								<ul>
									<li><a href="/im/investment01.do">주주구성</a></li>
									<li><a href="http://data.krx.co.kr/contents/MDC/MDI/mdiLoader/index.cmd?menuId=MDC0201020203" target="_blank" title="새창으로 보기">정기주총</a></li>
									<li><a href="/im/investment03.do">공시정보</a></li>
									<li><a href="/im/investment04.do">재무정보</a></li>
									<li><a href="/im/investment05.do?cm_cd=9400">IR자료실</a></li>
									<li><a href="/im/investment06.do">배당정보</a></li>
									<li><a href="/im/investment07.do">정기주총</a></li>
								</ul>
							</div>
							<!-- //mnb-3 -->
							<!-- mnb-4 -->
							<div id="mnb-4" class="mnb-list fade">
								<ul>
									<li><a href="/pc/pr-center01.do">Contact Us</a></li>
									<li><a href="/pc/pr-center02.do">CI 소개</a></li>
									<li><a href="/pc/pr-center03.do?cm_cd=9200">보도자료</a></li>
									
								</ul>
							</div>
							<!-- //mnb-4 -->
							<!-- mnb-5 -->
							<div id="mnb-5" class="mnb-list fade">
								<ul>
									<li><a href="/cs/cs-center01-list.do?cm_cd=9100">공지사항</a></li>
									<li><a href="/cs/cs-center02.do">자주하는 질문</a></li>
									<li><a href="/cs/cs-center03.do">보안정책</a></li>
									<li><a href="/cs/cs-center04.do">공정거래자율준수</a></li>
									<li><a href="/cs/cs-center05.do">전자민원센터</a></li>
								</ul>
							</div>
							<!-- //mnb-5 -->
							<!-- mnb-6 -->
							<div id="mnb-6" class="mnb-list fade">
								<ul>
									
									<li><a href="/ep/employment04.do?">인재상</a></li>
									<li><a href="/ep/employment05.do?">인사제도</a></li>
									<li><a href="/ep/employment06.do?">인재육성</a></li>
									<li><a href="/ep/employment07.do?">직무소개</a></li>
									<li><a href="https://nice.career.greetinghr.com" target="_blank" title="새창 NICE그룹 채용정보 안내 서비스 홈페이지로 이동합니다.">채용공고</a></li>
									
									
								</ul>
							</div>
							<!-- //mnb-6 -->
						</div>
						<!-- mnb-wrap -->
					</div>
					<!-- //mnb-content -->
				</div>
				<!-- //mobile-gnb -->
				<div class="mobile-background"></div>
			</div>
			<!-- //mobile-menu -->
		</div>	
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
	computed: {
		...mapGetters('userStore', ['isLogin']),
	},
	methods: {
		async showConfirm() {
			const headerNavigation = this;
			Swal.fire({
				title: '로그아웃 하시겠습니까?',
				text: "",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: '확인',
				cancelButtonText: '취소',

			}).then((result) => {
				if (result.isConfirmed) {
					this.userLogout();
					Swal.fire(
						'로그아웃이 완료되었습니다.',
					)
				}
			})
		},
		userLogout() {
			this.$store.dispatch('userStore/LOGOUT');
			this.$router.push('/');
		},
	},
};
</script>

